var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUserCheckAlt1Colored = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "user-check-alt-1"
}, /*#__PURE__*/React.createElement("path", {
  id: "Icon",
  d: "M8.16683 11.25L9.21683 12.25L11.6668 9.91667M2.3335 12.25C2.3335 9.99484 4.16167 8.16667 6.41683 8.16667C7.28439 8.16667 8.08876 8.43723 8.75016 8.89857M8.75016 4.08333C8.75016 5.372 7.70549 6.41667 6.41683 6.41667C5.12817 6.41667 4.0835 5.372 4.0835 4.08333C4.0835 2.79467 5.12817 1.75 6.41683 1.75C7.70549 1.75 8.75016 2.79467 8.75016 4.08333Z",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgUserCheckAlt1Colored);
export default ForwardRef;